import React from "react";
import { motion } from "framer-motion";
import { ThumbsUp, AlertCircle, ThumbsDown } from "lucide-react";

const PerformanceScore = () => {
  const performanceLevels = [
    {
      label: "Excellent Performance",
      icon: <ThumbsUp className="w-5 h-5 text-green-600" />,
      color: "bg-green-50 border-green-200 text-green-800",
      tips: [
        "CTR above 2.5%",
        "eCPM consistently high ($4+)",
        "Viewability above 75%",
        "Engaged and targeted traffic",
      ],
      reasons: [
        "Optimized ad placement",
        "High-quality content",
        "Diversified demand sources",
      ],
    },
    {
      label: "Average Performance",
      icon: <AlertCircle className="w-5 h-5 text-yellow-600" />,
      color: "bg-yellow-50 border-yellow-200 text-yellow-800",
      tips: [
        "CTR around 1.5% - 2.5%",
        "eCPM between $2 - $4",
        "Viewability between 50% - 75%",
        "Traffic might be broad or inconsistent",
      ],
      reasons: [
        "Non-optimized ad placement",
        "Limited user engagement",
        "Basic demand configuration",
      ],
    },
    {
      label: "Poor Performance",
      icon: <ThumbsDown className="w-5 h-5 text-red-600" />,
      color: "bg-red-50 border-red-200 text-red-800",
      tips: [
        "CTR below 1.5%",
        "eCPM under $2",
        "Viewability under 50%",
        "High bounce rate or bot traffic",
      ],
      reasons: [
        "Low content quality",
        "Improper ad positioning",
        "Unverified or low-demand ad sources",
      ],
    },
  ];

  return (
    <motion.div
      className="bg-white rounded-2xl p-8 shadow-xl"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2">
        📊 Understanding Performance Levels
      </h2>

      <div className="space-y-6">
        {performanceLevels.map((level, index) => (
          <div
            key={index}
            className={`p-6 rounded-xl border shadow-sm ${level.color}`}
          >
            <h3 className="text-lg font-semibold flex items-center gap-2 mb-2">
              {level.icon} {level.label}
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
              <div>
                <p className="font-medium underline mb-1">What It Looks Like:</p>
                <ul className="list-disc list-inside text-sm space-y-1">
                  {level.tips.map((tip, idx) => (
                    <li key={idx}>{tip}</li>
                  ))}
                </ul>
              </div>

              <div>
                <p className="font-medium underline mb-1">Possible Reasons:</p>
                <ul className="list-disc list-inside text-sm space-y-1">
                  {level.reasons.map((reason, idx) => (
                    <li key={idx}>{reason}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default PerformanceScore;
